module.exports = __webpack_public_path__ + "static/media/TS.0d5c1c0b.webp";